import type { Partner } from '../../services/partnerNetwork.types';
import type { FormEditPartner } from './EditPartnerDialog';
import { useStorePartnerMutation } from '../../services/partnerNetworkApi';

const useEditPartner = () => {
    const [updatePartner] = useStorePartnerMutation();

    const handleEditPartner = async (partner: Partner, formEditPartner: FormEditPartner) => {
        const editedPartner = {
            id: partner.id,
            name: formEditPartner.name,
            description: formEditPartner.description,
            status: partner.status,
            connectionType: partner.connectionType,
            accountProfile: partner.accountProfile,
        } as Partner;

        const result = await updatePartner(editedPartner);
        console.log(result);
    };

    return { handleEditPartner };
};

export default useEditPartner;
